import { AccountService } from './../_services/account.service';
import { Login } from '../_models/Login';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'on-common/_services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'on-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit, OnDestroy {
    msLoginSub;
    showMicrosoftLogin: boolean; // environment.windowsLogin;

    constructor(
        private accountService: AccountService,
        private toastService: ToastService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
    ) {}

    ngOnInit() {
        this.msLoginSub = this.activatedRoute.data.subscribe(
            (d) => (this.showMicrosoftLogin = d.msExternalLogin),
        );
    }

    ngOnDestroy() {
        this.msLoginSub.unsubscribe();
    }

    Login(loginmodel?: Login) {
        this.accountService
            .LogIn(loginmodel.username, loginmodel.password)
            .subscribe(
                (response) => {
                    if (response.access_token) {
                        this.toastService.success(this.translate.instant('auth.login-success') || 'Login successful');
                        if (
                            this.activatedRoute.snapshot.queryParams[
                                'returnUrl'
                            ]
                        ) {
                            this.router.navigateByUrl(
                                this.activatedRoute.snapshot.queryParams[
                                    'returnUrl'
                                ],
                            );
                        } else {
                            // TODO replace to default
                            this.router.navigate(['/expenses']);
                        }
                    } else {
                        this.toastService.error(
                            this.translate.instant('auth.login-error'),
                            this.translate.instant('auth.login-failed'),
                        );
                    }
                },
                (error) => {
                    if (error.error.indexOf('invalid_grant') > -1) {
                        this.toastService.error(
                            this.translate.instant('auth.invalid-credentials'),
                            this.translate.instant('auth.login-failed'),
                        );
                    } else {
                        this.toastService.error(
                            this.translate.instant('auth.unknown-error'),
                            this.translate.instant('auth.login-failed'),
                        );
                    }
                },
            );
    }
}
